import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GlobalLogo from "../../component/SvgIcons/GlobalLogo";
import IconKey from "../../component/SvgIcons/IconKey";
import IconLock from "../../component/SvgIcons/IconLock";
import IconSignIn from "../../component/SvgIcons/IconSignIn";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api"; 
import "./style.css";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const alert = useSwal();

  const handleLogin = async (event) => {
    event.preventDefault();
    setErrorMsg(""); // Clear any previous error message
    setLoading(true);

    if (!username) {
      setLoading(false);
      await alert("error", "Please enter the Username.");
      return;
    }

    if (!password) {
      setLoading(false);
      await alert("error", "Please enter the Password.");
      return;
    }

    try {
      const response = await api.post("/login", { username, password });
      console.log(username,password);  
      if (response.data && response.data.message === "Login successful!") {
        await alert("success", "🎉 Signed In Successfully");

        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("AdminUser_Name", username);

        // ✅ use response.data.data instead of response.data.user
        localStorage.setItem("email", response.data.data?.email || "");
        localStorage.setItem("contact", response.data.data?.contact || "");
        localStorage.setItem("address", response.data.data?.address || "");
        localStorage.setItem("AdminUser_Type", response.data.data?.type || "User");

        console.log("Login api", response.data);

        // ✅ Redirect based on type
        if (response.data.data?.type === "Admin") {
          navigate("/dashboard");
        } else {
          navigate("/blog-view");
        }
      } else {
        await alert("error", "🤔 Oops! Something Went Wrong");
      }

    } catch (error) {
      console.error("Error during login:", error);
      await alert("error", "An error occurred during login. Please try again.");
    }finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <section className="loginpage">
      <ul className="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      <form className="loginform" onSubmit={handleLogin}>
        <div className="loginforminner">
          <div className="loginlogo">
            <GlobalLogo />
          </div>
          <h5>Welcome Back! Please Log In</h5>
          {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
          <div className="input-container formfield">
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Enter User Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            {/* <label htmlFor="username">Enter User Name</label> */}
            <div className="underline"></div>
            <span>
              <IconLock />
            </span>
          </div>
          <div className="input-container formfield mb-0">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter Password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* <label htmlFor="password">Enter Password</label> */}
            <div className="underline"></div>
            <span className="icon-btn" onClick={() => setShowPassword(!showPassword)}>
              <IconKey /> 
            </span>
          </div>              
          <button type="submit" disabled={loading}>
            {loading ? "Sign in..." : "Sign in"} {loading ? <IconSignIn /> : <IconSignIn />}
          </button>
          <Link to="#" className="forget">Forget Password</Link>
        </div>
      </form>
    </section>
  );
}
